import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Modal, Button, ProgressBar } from 'react-bootstrap';
import { Dropdown, ButtonGroup } from "react-bootstrap";
import { FaPlus, FaCheck, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaBell, FaArrowRight, FaArrowLeft, FaFileImport, FaPaperPlane, FaUserCheck, FaChevronUp, FaChevronDown, FaCog, FaFileExport, FaTrashAlt } from 'react-icons/fa';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css'; // Importez le style bubble
import axios from 'axios';
import { getAuthToken } from '../../authToken';



const Liste_dictionnaire = ({ theme }) => {
    useAuth();
    const [dictionnaire, setDictionnaire] = useState([]);
    const user_id = localStorage.getItem('user_id');

    const [expandedMessages, setExpandedMessages] = useState({}); // État pour suivre les messages étendus

    const [selectedDictionnaire, setSelectedDictionnaire] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'descending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showViderModal, setShowViderModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [newDictionnaire, setNewDictionnaire] = useState({
        theme: '',
        definition: '',
    });
    const [modifDictionnaire, setModifDictionnaire] = useState({
        theme: '',
        definition: '',
    });
    const [isLoading, setIsLoading] = useState(false); // Pour gérer le loader
    const [showInfo, setShowInfo] = useState(false);
    const [isLoadingList, setIsLoadingList] = useState(false); // Pour le chargement de la liste



    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Dictionnaire"; // Définit le titre de la page
        }
    }, [user_id]);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalItems = dictionnaire.length;

    const navigate = useNavigate();




    // Ouvrir/Fermer le modal Ajouter
    const handleShowAddModal = () => setShowAddModal(true);
    const handleCloseAddModal = () => setShowAddModal(false);


    const handleShowEditModal = () => setShowEditModal(true);
    const handleCloseEditModal = () => setShowEditModal(false);

    const handleShowImportModal = () => {
        setShowImportModal(true);
    };

    const handleCloseImportModal = () => {
        setShowImportModal(false);
    };

    const handleShowDetailsModal = () => setShowDetailsModal(true);
    const handleCloseDetailsModal = () => setShowDetailsModal(false);

    const [selectedFile, setSelectedFile] = useState(null);

    const [progress, setProgress] = useState(0);
    const [isImporting, setIsImporting] = useState(false);

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]); // Met à jour l'état du fichier sélectionné
    };

    const handleImport = async () => {
        if (selectedFile) {
            try {
                const formData = new FormData();
                formData.append('file', selectedFile); // Ajoute le fichier sélectionné au FormData

                setIsImporting(true); // Indique que l'importation commence
                setProgress(0); // Réinitialise la progression

                // Récupérer le token d'authentification
                const token = localStorage.getItem('access_token');
                console.log("Token récupéré avec succès");

                const xhr = new XMLHttpRequest();
                xhr.open('POST', `${process.env.REACT_APP_HOTE}/importer-dictionnaire/${user_id}/`, true);

                // Ajouter le token dans l'en-tête Authorization
                xhr.setRequestHeader('Authorization', `Bearer ${token}`);

                // Écoute l'événement de progression
                xhr.upload.addEventListener('progress', (event) => {
                    if (event.lengthComputable) {
                        const percentComplete = (event.loaded / event.total) * 100;
                        setProgress(percentComplete); // Met à jour la barre de progression
                    }
                });

                xhr.onload = () => {
                    if (xhr.status === 200) {
                        const data = JSON.parse(xhr.responseText);
                        console.log("Importation réussie :", data);
                        setShowImportModal(false);
                        setAlert({ message: 'Importation réussie !', type: 'success' });
                        fetchDictionnaire();

                        // Clear alert after 5 seconds
                        setTimeout(() => {
                            setAlert({ message: '', type: '' });
                        }, 3000);
                    } else {
                        try {
                            const data = JSON.parse(xhr.responseText);
                            console.error("Erreur lors de l'importation :", xhr.responseText);
                            setAlert({ message: data.message || 'Erreur lors de l\'importation', type: 'danger' });
                        } catch (e) {
                            setAlert({ message: 'Erreur lors de l\'importation', type: 'danger' });
                        }
                    }
                    setIsImporting(false); // Indique que l'importation est terminée
                };

                xhr.onerror = () => {
                    console.error("Erreur lors de l'importation :", xhr.statusText);
                    setAlert({ message: 'Erreur lors de l\'importation', type: 'danger' });

                    // Clear alert after 5 seconds
                    setTimeout(() => {
                        setAlert({ message: '', type: '' });
                    }, 5000);
                    setIsImporting(false); // Indique que l'importation est terminée
                };

                xhr.send(formData); // Envoie le formulaire avec le fichier
            } catch (error) {
                console.error("Erreur lors de la récupération du token :", error);
                setAlert({ message: 'Erreur d\'authentification. Veuillez vous reconnecter.', type: 'danger' });
                setIsImporting(false);
            }
        } else {
            alert("Veuillez sélectionner un fichier à importer.");
        }
    };

    const handleImportPdf = () => {
        if (selectedFile) {
            const formData = new FormData();
            formData.append('file', selectedFile); // Ajoute le fichier sélectionné au FormData

            setIsImporting(true); // Indique que l'importation commence
            setProgress(0); // Réinitialise la progression

            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${process.env.REACT_APP_HOTE}/importer-dictionnaire-pdf/`, true);

            // Écoute l'événement de progression
            xhr.upload.addEventListener('progress', (event) => {
                if (event.lengthComputable) {
                    const percentComplete = (event.loaded / event.total) * 100;
                    setProgress(percentComplete); // Met à jour la barre de progression
                }
            });

            xhr.onload = () => {
                if (xhr.status === 200) {
                    const data = JSON.parse(xhr.responseText);
                    console.log("Importation réussie :", data);
                    setShowImportModal(false);
                    setAlert({ message: 'Importation réussie !', type: 'success' });
                    fetchDictionnaire();

                    // Clear alert after 5 seconds
                    setTimeout(() => {
                        setAlert({ message: '', type: '' });
                    }, 3000);
                } else {
                    console.error("Erreur lors de l'importation :", xhr.responseText);
                    setAlert({ message: 'Erreur lors de l\'importation', type: 'danger' });

                    // Clear alert after 5 seconds
                    setTimeout(() => {
                        setAlert({ message: '', type: '' });
                    }, 5000);
                }
                setIsImporting(false); // Indique que l'importation est terminée
            };

            xhr.onerror = () => {
                console.error("Erreur lors de l'importation :", xhr.statusText);
                setAlert({ message: 'Erreur lors de l\'importation', type: 'danger' });

                // Clear alert after 5 seconds
                setTimeout(() => {
                    setAlert({ message: '', type: '' });
                }, 5000);
                setIsImporting(false); // Indique que l'importation est terminée
            };

            xhr.send(formData); // Envoie le formulaire avec le fichier
        } else {
            alert("Veuillez sélectionner un fichier à importer.");
        }
    };


    // Fetching dictionnaire data from API
    const fetchDictionnaire = async () => {
        setIsLoadingList(true);
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-dictionnaire/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            // const response = await fetch(process.env.REACT_APP_HOTE + `/liste-dictionnaire/`);
            if (response.ok) {
                const data = await response.json();
                setDictionnaire(data);
            } else {
                console.error('Erreur lors de la récupération des quiz');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoadingList(false); // Fin du chargement
        }
    };

    useEffect(() => {
        fetchDictionnaire();
    }, []);


    const handleInputChange = (e) => {
        const { name, value } = e.target || e; // Au cas où e.target serait indéfini, on prend directement e

        // Si l'événement vient de ReactQuill, on prend la valeur du texte
        if (e.target instanceof HTMLDivElement) {
            setNewDictionnaire({
                ...newDictionnaire,
                [name]: value,
            });
        } else {
            setNewDictionnaire({
                ...newDictionnaire,
                [name]: value,
            });
        }
    };

    const handleEnregDictionnaire = async () => {
        setIsLoading(true); // Affiche le loader sur le bouton
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(process.env.REACT_APP_HOTE + `/ajouter-ligne-dictionnaire/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(newDictionnaire),
            });
            const data = await response.json();

            // console.log('response:', response)
            if (response.ok) {
                showAlert('Thème enregistré avec succès');
                handleCloseAddModal(); // Ferme le modal
                fetchDictionnaire(); // Recharge la liste des thème

                // Réinitialise le formulaire en définissant un état vide
                setNewDictionnaire({
                    theme: '',
                    definition: '',
                });
            } else {
                // const errorquiz = await response.json();
                console.error('Erreur lors de l’enregistrement du thème', data);
            }
        } catch (error) {
            console.error('Erreur:', error);
        } finally {
            setIsLoading(false); // Arrête le loader sur le bouton
        }
    };

    useEffect(() => {
        const fetchDictionnaireModif = async () => {
            if (!selectedDictionnaire || !selectedDictionnaire.id) {
                console.warn('Aucun dictionnaire sélectionné.');
                return;
            }

            try {
                setIsLoading(true);

                const token = localStorage.getItem('access_token');

                const response = await fetch(`${process.env.REACT_APP_HOTE}/dictionnaire-info/${selectedDictionnaire.id}/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                // const response = await fetch(
                //     `${process.env.REACT_APP_HOTE}/dictionnaire-info/${selectedDictionnaire.id}/`
                // );

                if (!response.ok) {
                    throw new Error('Erreur lors de la récupération du thème.');
                }

                const data = await response.json();

                // Mettre à jour l'état avec les données récupérées
                setModifDictionnaire({
                    theme: data.theme, // Ajusté pour correspondre au format de votre API
                    definition: data.definition,
                });

                console.log('Données récupérées :', data);
            } catch (error) {
                console.error('Erreur lors de la récupération des données du thème :', error);
            } finally {
                setIsLoading(false); // Désactive le spinner
            }
        };

        fetchDictionnaireModif();
    }, [selectedDictionnaire]); // Dépendance sur selectedDictionnaire




    const handleModifierDictionnaire = async (event) => {
        event.preventDefault();
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-ligne-dictionnaire/${selectedDictionnaire.id}/${user_id}/`, {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(modifDictionnaire),
            });
            if (response.ok) {
                showAlert("Thème modifiée avec succès !");
                handleCloseEditModal();
            } else {
                alert("Erreur lors de la modification du thème.");
            }
        } catch (error) {
            console.error("Erreur réseau :", error);
        }
    };

    // Handle alerts
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        fetchDictionnaire();
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    };

    // Handle row click
    const handleRowClick = (dictionnaire) => {
        setSelectedDictionnaire(dictionnaire);
    };


    // Filter quiz by search term
    const filteredDictionnaire = dictionnaire.filter((n) =>
        n.theme.toLowerCase().includes(searchTerm.toLowerCase()) ||
        n.definition.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Sort quiz
    const sortedDictionnaire = [...filteredDictionnaire].sort((a, b) => {
        if (sortConfig.key) {
            const aValue = a[sortConfig.key];
            const bValue = b[sortConfig.key];
            if (aValue < bValue) {
                return sortConfig.direction === "ascending" ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortConfig.direction === "ascending" ? 1 : -1;
            }
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Pagination logic
    const indexOfLastDictionnaire = currentPage * itemsPerPage;
    const indexOfFirstDictionnaire = indexOfLastDictionnaire - itemsPerPage;
    const currentDictionnaire = sortedDictionnaire.slice(indexOfFirstDictionnaire, indexOfLastDictionnaire);
    const totalPages = Math.ceil(sortedDictionnaire.length / itemsPerPage);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };


    // Handle show delete modal
    const handleShowDeleteModal = () => {
        if (selectedDictionnaire) {
            setShowDeleteModal(true);
        }
    };

    const handleCloseDeleteModal = () => setShowDeleteModal(false);


    const handleShowViderModal = () => {
        setShowViderModal(true);
    };

    const handleCloseViderModal = () => setShowViderModal(false);

    const handleVider = async () => {
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/vider-dictionnaire/${user_id}/`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            // const response = await fetch(process.env.REACT_APP_HOTE + `/vider-dictionnaire/${user_id}/`, {
            //     method: 'OPTIONS',
            // });

            if (response.ok) {
                fetchDictionnaire()
                showAlert('Table vidée avec succès !');
            } else {
                console.error('Erreur lors de la suppression des QCM');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setShowViderModal(false);
        }
    };

    const handleDeleteDictionnaire = async () => {
        if (selectedDictionnaire) {
            try {
                const token = localStorage.getItem('access_token');

                const response = await fetch(`${process.env.REACT_APP_HOTE}/supprimer-ligne-dictionnaire/${selectedDictionnaire.id}/${user_id}/`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                // const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-ligne-dictionnaire/${selectedDictionnaire.id}/${user_id}/`, {
                //     method: 'DELETE',
                // });

                if (response.ok) {
                    setDictionnaire(dictionnaire.filter((dictionnaire) => dictionnaire.id !== selectedDictionnaire.id));
                    setSelectedDictionnaire(null);
                    showAlert("Thème supprimée avec succès !");
                } else {
                    console.error('Erreur lors de la suppression du Thème');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }], // En-têtes
            ['bold', 'italic', 'underline'], // Styles de texte
            ['link', 'image'], // Ajouter des liens et des images
            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Listes
            ['clean'] // Bouton pour effacer le format
            [{ 'align': [] }], // Alignement du texte
            ['link', 'image'], // Ajouter des liens et des images
            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Listes
        ],
    };

    // Pagination logic
    const indexOfLastSimulation = currentPage * itemsPerPage;
    const indexOfFirstSimulation = indexOfLastSimulation - itemsPerPage;

    // Gestion du clic sur "Voir plus" ou "Voir moins"
    const toggleMessageExpansion = (id) => {
        setExpandedMessages((prev) => ({
            ...prev,
            [id]: !prev[id], // Inverse l'état pour ce message spécifique
        }));
    };


    const [showExportDictModal, setShowExportDictModal] = useState(false);
    const [exportFields, setExportFields] = useState({ db: "fr", tag: "" });
    const [isLoadingBouton, setIsLoadingBouton] = useState(false);


    const handleExportDict = async () => {
        setIsLoadingBouton(true);
        try {
            const token = localStorage.getItem('access_token');

            const url = `${process.env.REACT_APP_HOTE}/export-dictionnaire/${user_id}/`;

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/csv",
                    'Authorization': `Bearer ${token}`
                },
            });

            if (!response.ok) {
                throw new Error("Erreur lors de l'export du dictionnaire");
            }

            // Téléchargement du fichier
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = "dictionnaire_export.xlsx";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(downloadUrl);

            setShowExportDictModal(false);
            showAlert("Exportation du dictionnaire terminée avec succès !");
        } catch (error) {
            console.error("Erreur d'export:", error);
            showAlert("Une erreur est survenue lors de l'export du dictionnaire.");
        } finally {
            setIsLoadingBouton(false);
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("AdminQuiz")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} theme={theme} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><pe-7s-tools fa-2x size={25} className='mr-2' /> Dictionnaire de thèmes et accronymes
                                <span
                                    className="ml-3 toggle-icon"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setShowInfo(!showInfo)}
                                >
                                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                </span>
                            </h2>

                            <div className={`info-box ${showInfo ? "open" : ""}`}>
                                <small>Administration du Dictionnaire de thèmes et accronymes.</small>
                            </div>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/Liste-dictionnaire`}>Dictionnaire</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Thèmes et accronymes</h5>
                                <div className="d-flex mb-3 mt-md-0" style={{ gap: '10px' }}>
                                    {/* Bouton Ajouter */}
                                    <button
                                        onClick={handleShowAddModal}
                                        className="btn btn-success d-flex align-items-center justify-content-center"
                                    >
                                        <FaPlus />
                                        <span className="d-none d-sm-inline ml-2">Ajouter</span>
                                    </button>

                                    {/* Boutons Modifier & Supprimer (désactivés si aucun thème sélectionné) */}
                                    <button
                                        onClick={() => handleShowEditModal(selectedDictionnaire)}
                                        disabled={!selectedDictionnaire}
                                        className={`btn d-flex align-items-center ${selectedDictionnaire ? 'btn-success' : 'btn-default text-dark'}`}
                                    >
                                        <FaEdit />
                                        <span className="d-none d-sm-inline ml-2">Modifier</span>
                                    </button>
                                    <button
                                        onClick={handleShowDeleteModal}
                                        disabled={!selectedDictionnaire}
                                        className={`btn d-flex align-items-center ${selectedDictionnaire ? 'btn-success' : 'btn-default text-dark'}`}
                                    >
                                        <FaTrash />
                                        <span className="d-none d-sm-inline ml-2">Supprimer</span>
                                    </button>

                                    {/* Menu déroulant pour Import/Export/Vider */}
                                    <Dropdown as={ButtonGroup}>
                                        <Dropdown.Toggle variant="success">
                                            <FaCog /> <span className="d-none d-sm-inline ml-2">Actions</span>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={handleShowImportModal}>
                                                <FaFileImport /> Importer
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => setShowExportDictModal(true)}>
                                                <FaFileExport /> Exporter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleShowViderModal} className="text-danger">
                                                <FaTrashAlt /> Vider
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>



                            {/* Modal Ajouterrrrrr Quiz */}
                            <Modal show={showAddModal} onHide={handleCloseAddModal}>
                                <Modal.Header>
                                    <Modal.Title>Ajout du thème</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form onSubmit={handleEnregDictionnaire}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Thème</Form.Label>
                                            <Form.Control
                                                type="text"
                                                required
                                                value={newDictionnaire.theme}
                                                onChange={(event) => {
                                                    setNewDictionnaire({
                                                        ...newDictionnaire,
                                                        theme: event.target.value, // Utilisez event.target.value pour obtenir la valeur de l'entrée
                                                    });
                                                }}
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Définition</Form.Label>
                                            <ReactQuill
                                                theme="snow"
                                                value={newDictionnaire.definition}
                                                onChange={(content) => {
                                                    setNewDictionnaire({
                                                        ...newDictionnaire,
                                                        definition: content, // mettez directement le contenu de l'éditeur
                                                    });
                                                }}
                                                modules={modules} // Appliquez les modules personnalisés
                                            />
                                        </Form.Group>

                                        {/* Section des boutons */}
                                        <div className="d-flex justify-content-end mt-4">
                                            <Button
                                                variant="secondary"
                                                className="me-2 mr-2"
                                                onClick={handleCloseAddModal}
                                            >
                                                Annuler
                                            </Button>
                                            <Button
                                                variant="success"
                                                className="me-2 mr-2"
                                                onClick={() => handleEnregDictionnaire()}
                                            >
                                                {isLoading ? (
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                ) : (
                                                    <>
                                                        Enregistrer
                                                    </>
                                                )}

                                            </Button>
                                        </div>
                                    </Form>
                                </Modal.Body>
                            </Modal>

                            {/* Modal Modifierr Quiz */}
                            <Modal show={showEditModal} onHide={handleCloseEditModal}>
                                <Modal.Header>
                                    <Modal.Title>Mise à jour du thème</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form onSubmit={handleModifierDictionnaire}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Thème</Form.Label>
                                            <Form.Control
                                                type="text"
                                                required
                                                value={modifDictionnaire.theme}
                                                onChange={(event) => {
                                                    setModifDictionnaire({
                                                        ...modifDictionnaire,
                                                        theme: event.target.value, // Utilisez event.target.value pour obtenir la valeur
                                                    });
                                                }}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Définition</Form.Label>
                                            <ReactQuill
                                                theme="snow"
                                                value={modifDictionnaire.definition}
                                                onChange={(content) => {
                                                    setModifDictionnaire({
                                                        ...modifDictionnaire,
                                                        definition: content, // Mettre à jour le definition de l'éditeur
                                                    });
                                                }}
                                                modules={modules} // Appliquez les modules personnalisés
                                            />
                                        </Form.Group>

                                        {/* Boutons */}
                                        <div className="d-flex justify-content-end mt-4">
                                            <Button
                                                variant="secondary"
                                                className="me-2 mr-2"
                                                onClick={handleCloseEditModal}
                                            >
                                                Annuler
                                            </Button>
                                            <Button
                                                variant="success"
                                                type="submit"
                                            >
                                                {isLoading ? (
                                                    <span
                                                        className="spinner-border spinner-border-sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                ) : (
                                                    <>
                                                        Enregistrer
                                                    </>
                                                )}
                                            </Button>
                                        </div>
                                    </Form>
                                </Modal.Body>
                            </Modal>

                            {alert.message && (
                                <div className={`alert alert-${alert.type} row justify-content-between position-relative m-2 mt-2`}>
                                    <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                                    <span
                                        onClick={fermerNotif}
                                        style={{
                                            position: 'absolute',
                                            top: '0px',
                                            right: '10px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <i className='fa fa-close'></i>
                                    </span>
                                </div>
                            )}

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control"
                                                    style={{ maxWidth: '150px', width: '100%' }}
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                {isLoadingList ? (
                                                    <div className="text-center py-5">
                                                        <div className="spinner-border text-success" role="status">
                                                        </div>
                                                        <p className="mt-2 text-muted">Chargement des thèmes...</p>
                                                    </div>
                                                ) : (
                                                    <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                        <thead>
                                                            <tr>
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('theme')}>Thème{sortConfig.key === 'theme'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('definition')}>Définition {sortConfig.key === 'definition'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {currentDictionnaire.length > 0 ? currentDictionnaire.map((n) => (
                                                                <tr
                                                                    key={n.id}
                                                                    className={`bg-white ${selectedDictionnaire && selectedDictionnaire.id === n.id ? 'bg-success text-white' : ''}`}
                                                                    onClick={() => handleRowClick(n)}
                                                                >
                                                                    {/* <td><span dangerouslySetInnerHTML={{ __html: n.theme }}></span></td> */}
                                                                    <td>
                                                                        {/* Afficher le message avec le bouton Voir plus/Voir moins */}
                                                                        {expandedMessages[n.id] ? (
                                                                            <>
                                                                                <span dangerouslySetInnerHTML={{ __html: n.theme }}></span>
                                                                                <button
                                                                                    onClick={() => toggleMessageExpansion(n.id)}
                                                                                    className="btn btn-link text-primary p-0 ms-2"
                                                                                >
                                                                                    Voir moins
                                                                                </button>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <span
                                                                                    dangerouslySetInnerHTML={{
                                                                                        __html: n.theme.length > 50
                                                                                            ? n.theme.substring(0, 50) + "..."
                                                                                            : n.theme,
                                                                                    }}
                                                                                ></span>
                                                                                {n.theme.length > 50 && (
                                                                                    <button
                                                                                        onClick={() => toggleMessageExpansion(n.id)}
                                                                                        className="btn btn-link text-primary p-0 ms-2"
                                                                                    >
                                                                                        Voir plus
                                                                                    </button>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {/* Afficher le message avec le bouton Voir plus/Voir moins */}
                                                                        {expandedMessages[n.id] ? (
                                                                            <>
                                                                                <span dangerouslySetInnerHTML={{ __html: n.definition }}></span>
                                                                                <button
                                                                                    onClick={() => toggleMessageExpansion(n.id)}
                                                                                    className="btn btn-link text-primary p-0 ms-2"
                                                                                >
                                                                                    Voir moins
                                                                                </button>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <span
                                                                                    dangerouslySetInnerHTML={{
                                                                                        __html: n.definition.length > 100
                                                                                            ? n.definition.substring(0, 100) + "..."
                                                                                            : n.definition,
                                                                                    }}
                                                                                ></span>
                                                                                {n.definition.length > 100 && (
                                                                                    <button
                                                                                        onClick={() => toggleMessageExpansion(n.id)}
                                                                                        className="btn btn-link text-primary p-0 ms-2"
                                                                                    >
                                                                                        Voir plus
                                                                                    </button>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </td>
                                                                    {/* <td>{n.theme}</td>
                                                                <td>{n.definition}</td> */}
                                                                </tr>
                                                            )) : (
                                                                <tr>
                                                                    <td colSpan="5">Aucun thème à afficher</td>
                                                                </tr>
                                                            )}
                                                        </tbody>

                                                    </table>
                                                )}
                                            </div>
                                            {/* Pagination Controls */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                {/* <div className="dataTables_info" role="status" aria-live="polite">
                                                    {`Élément ${indexOfFirstSimulation + 1} à ${Math.min(indexOfLastSimulation, totalItems)} sur ${totalItems}`}
                                                </div> */}
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstSimulation + 1} à ${Math.min(indexOfLastSimulation, totalItems)} sur ${totalItems}`}
                                                </div>

                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5; // Nombre total de pages à afficher
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        // Ajuster le startPage si la fin dépasse le total des pages
                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        // Ajout des boutons de pages
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    {/* Bouton pour aller à la dernière page */}
                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Modal de confirmation de suppression */}
                <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                    <Modal.Header>
                        <Modal.Title>Confirmer la suppression</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Êtes-vous sûr de vouloir supprimer ?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseDeleteModal}>Annuler</Button>
                        <Button variant="success" onClick={handleDeleteDictionnaire}>Supprimer</Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal de l'importation */}
                <Modal show={showImportModal} onHide={handleCloseImportModal}>
                    <Modal.Header>
                        <Modal.Title>Importation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group controlId="formFile" className="mt-3">
                            <Form.Label>Choisissez un fichier à importer</Form.Label>
                            <Form.Control type="file" onChange={handleFileChange} />
                        </Form.Group>
                        {isImporting && (
                            <div className="mt-3">
                                <ProgressBar now={progress} label={`${Math.round(progress)}%`} />
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => handleCloseImportModal()}
                            disabled={isImporting} // Désactive le bouton si aucun fichier n'est sélectionné ou si l'importation est en cours
                        >
                            Annuler
                        </Button>
                        <Button
                            variant="success"
                            onClick={() => handleImport()}
                            disabled={!selectedFile || isImporting} // Désactive le bouton si aucun fichier n'est sélectionné ou si l'importation est en cours
                        >
                            importer
                        </Button>
                        {/* <Button
                            variant="success"
                            onClick={() => handleImportPdf()}
                            disabled={!selectedFile || isImporting} // Désactive le bouton si aucun fichier n'est sélectionné ou si l'importation est en cours
                        >
                            Pdf
                        </Button> */}
                    </Modal.Footer>
                </Modal>

                <Modal show={showViderModal} onHide={handleCloseViderModal}>
                    <Modal.Header>
                        <Modal.Title>Confirmer la Suppression</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Êtes-vous sûr de vouloir vider la Table ?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseViderModal}>
                            Annuler
                        </Button>
                        <Button variant="success" onClick={handleVider}>
                            Confirmer
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={showExportDictModal} onHide={() => setShowExportDictModal(false)}>
                    <Modal.Header>
                        <Modal.Title>Exporter le dictionnaire</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Voulez-vous exporter l'ensemble du dictionnaire au format CSV ?</p>
                        <p className="text-muted">Le fichier contiendra tous les thèmes et leurs définitions.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowExportDictModal(false)} disabled={isLoading}>
                            Annuler
                        </Button>
                        <Button variant="success" onClick={handleExportDict} disabled={isLoading}>
                            {isLoadingBouton ? (
                                <>
                                    {/* <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> */}
                                    <span className="ms-2">Export en cours...</span>
                                </>
                            ) : (
                                "Exporter"
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div >
    );
};

export default Liste_dictionnaire